import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IAuthFederationAdminRequestBody, IGetAuthFederationAdminResponse } from '../service/AuthFederationService';

export function patchAuthFederationAdminRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'PATCH',
    endpoint: 'auth-federation/admin',
    serverWideRequest: false
  };
}

export function callPatchAuthFederationAdminRequest(
  body: IAuthFederationAdminRequestBody
): Promise<IGetAuthFederationAdminResponse> {
  return makeJsonRestApiRequest<IAuthFederationAdminRequestBody, IGetAuthFederationAdminResponse>({
    config: patchAuthFederationAdminRequestConfig(),
    request: body
  });
}
